module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_count_rank/4_34c894a4e23964ab3af69c3e7bf9b74d.png";